import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// components
import ContactBtn from "./components/contact-btn/ContactBtn";
import Layout from './containers/layout/Layout';

// routes
import AboutMe from './routes/about';
import Homepage from './routes/homepage';
import Projects from "./routes/projects";
import Resume from "./routes/resume";


function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="about" element={<AboutMe />} />
          <Route path="portfolio" element={<Projects />} />
          <Route path="resume" element={<Resume />} />
        </Routes>
        <ContactBtn />
      </Layout>
    </BrowserRouter>
  );
}

export default App;
